import { render, staticRenderFns } from "./SelectedComponentItems.vue?vue&type=template&id=72ed48a9"
import script from "./SelectedComponentItems.vue?vue&type=script&lang=ts"
export * from "./SelectedComponentItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports